module.exports = __webpack_public_path__ + "static/media/ai.e5b2ad5b.gif";